var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"navbar-brand",attrs:{"to":{ name: 'LandingPage' }}},[_c('div',{staticClass:"logo"},[_c('h2',[_vm._v(" "+_vm._s(_vm.theme.name)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }